export default __webpack_public_path__ + "static/media/mypicture.486fe6e0.png";